import FileSaver from "file-saver";
import http from "./controllerFetch";
import { format } from "date-fns";

let data =  format(new Date(), "yyyyMMdd");

class giacenzeService {
    get( params = {}) {
        return http.get('giacenze/read', { params });
    }
    inventarioGiacenzaMgExcel (param , nomeMag) {
       //console.log('ci sono');
        http.get('giacenze/readExcell', {
            params: param,
            responseType: 'arraybuffer',
            headers: {
              'Accept': 'application/pdf'
            }
        })
        .then(response => {
           //console.log(response);
            // response.data is an empty object

            const blob = new Blob([response.data], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            FileSaver.saveAs(blob, data+'_giacenze_'+(nomeMag.trim())+'.xlsx' );
        });
    }
}
export default new giacenzeService();